import { render, staticRenderFns } from "./OpeningHoursSubGroups.vue?vue&type=template&id=4532592f&"
import script from "./OpeningHoursSubGroups.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursSubGroups.vue?vue&type=script&lang=js&"
import style0 from "./OpeningHoursSubGroups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VFadeTransition,VIcon})
